// src/components/shared/modals/PlaceholderCreationModal.tsx
// Wrapper around UnifiedCourseModal for semester placeholder creation.

import UnifiedCourseModal from './UnifiedCourseModal';

export interface PlaceholderData {
  title?: string;
  credits?: number;
  placeholderType?: string;
  notes?: string;
  requirements?: Record<string, unknown> | { [key: string]: unknown };
  gen_ed?: unknown;
  gen_ed_area?: unknown;
  gen_ed_requirements?: unknown;
  [key: string]: unknown;
}

export interface PlaceholderCreationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (placeholderData: PlaceholderData, semester: string | null | undefined) => void;
  editingPlaceholder?: { [key: string]: unknown } | null;
  targetSemester?: string | null;
}

const PlaceholderCreationModal = ({
  isOpen,
  onClose,
  onSubmit,
  editingPlaceholder,
  targetSemester,
}: PlaceholderCreationModalProps) => {
  const handleSubmit = (
    courseData: Record<string, unknown>,
    semester: string | null | undefined
  ) => {
    const data = courseData as PlaceholderData;
    const placeholderData: PlaceholderData = {
      title: data.title,
      credits: data.credits,
      placeholderType: data.placeholderType || 'elective',
      notes: data.notes || '',
      requirements: data.requirements || {},
      gen_ed: data.gen_ed,
      gen_ed_area: data.gen_ed_area,
      gen_ed_requirements: data.gen_ed_requirements,
    };

    onSubmit(placeholderData, semester || targetSemester);
  };

  return (
    <UnifiedCourseModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      context="semester"
      targetSemester={targetSemester}
      editingPlaceholder={editingPlaceholder}
    />
  );
};

export default PlaceholderCreationModal;
